import {
  ADD_CAMPAIGN_FORMAT,
  DELETE_CAMPAIGN_FORMAT,
  GET_CAMPAIGN_FORMAT_PROFILE,
  GET_CAMPAIGN_FORMATS_LIST,
  HIDE_CAMPAIGN_FORMATS_LIST_LOADER,
  SET_CAMPAIGN_FORMAT_PROFILE,
  SET_CAMPAIGN_FORMATS_LIST,
  SET_ERROR_CAMPAIGN_FORMAT_PROFILE,
  SHOW_CAMPAIGN_FORMATS_LIST_LOADER,
  UPDATE_CAMPAIGN_FORMAT_PROFILE
} from "./actionTypes";

export const getCampaignFormatsList = data => ({
  type: GET_CAMPAIGN_FORMATS_LIST,
  payload: data
})

export const setCampaignFormatsList = payload => ({
  type: SET_CAMPAIGN_FORMATS_LIST,
  payload
})

export const showCampaignFormatsListLoader = () => ({
  type: SHOW_CAMPAIGN_FORMATS_LIST_LOADER
})

export const hideCampaignFormatsListLoader = () => ({
  type: HIDE_CAMPAIGN_FORMATS_LIST_LOADER
})

export const addCampaignFormat = (format = {}, data = {}) => ({
  type: ADD_CAMPAIGN_FORMAT,
  payload: { format, data }
});

export const deleteCampaignFormat = (id, data = {}) => ({
  type: DELETE_CAMPAIGN_FORMAT,
  payload: { id, data }
});

export const getCampaignFormatProfile = id => ({
  type: GET_CAMPAIGN_FORMAT_PROFILE,
  payload: id
})

export const setCampaignFormatProfile = payload => ({
  type: SET_CAMPAIGN_FORMAT_PROFILE,
  payload
})

export const updateCampaignFormatProfile = (id, format = {}, data = {}) => ({
  type: UPDATE_CAMPAIGN_FORMAT_PROFILE,
  payload: {id, format, data }
})

export const setErrorCampaignFormatProfile = payload => ({
  type: SET_ERROR_CAMPAIGN_FORMAT_PROFILE,
  payload
})